// custom
export const FIELD_TYPE_FILE = 0;
export const FIELD_TYPE_TEXT = 1;
export const FIELD_TYPE_NUMBER = 2;
export const FIELD_TYPE_BOOLEAN = 3;
export const FIELD_TYPE_CHECKBOXES = 4;
export const FIELD_TYPE_RADIO = 5;
export const FIELD_TYPE_DATE = 6;
export const FIELD_TYPE_PERIOD = 7;
export const FIELD_TYPE_LIST_SINGLE = 8;
export const FIELD_TYPE_LIST_MULTIPLE = 9;

export const CUSTOM_TYPES = {
    [FIELD_TYPE_FILE]: { id: "file", name: "Файл", isSystem: false },
    [FIELD_TYPE_TEXT]: { id: "text", name: "Текстовое поле", isSystem: false },
    [FIELD_TYPE_NUMBER]: { id: "number", name: "Число", isSystem: false },
    [FIELD_TYPE_BOOLEAN]: { id: "boolean", name: "Логический", isSystem: false, isBoolean: true },
    [FIELD_TYPE_CHECKBOXES]: {
        id: "checkboxes",
        name: "Список с чекбоксами",
        isSystem: false,
        hasDictionary: true,
        isVariants: true,
    },
    [FIELD_TYPE_RADIO]: {
        id: "radio",
        name: "Список с радиокнопками",
        isSystem: false,
        hasDictionary: true,
        isVariants: true,
    },
    [FIELD_TYPE_DATE]: { id: "date", name: "Дата", isSystem: false },
    [FIELD_TYPE_PERIOD]: { id: "period", name: "Период", isSystem: false },
    [FIELD_TYPE_LIST_SINGLE]: {
        id: "list-single",
        name: "Список с выбором одного варианта",
        isSystem: false,
        hasDictionary: true,
        isList: true,
    },
    [FIELD_TYPE_LIST_MULTIPLE]: {
        id: "list-multiple",
        name: "Список с множественным выбором",
        isSystem: false,
        hasDictionary: true,
        isList: true,
    },
};

export const CUSTOM_TYPES_LIST = Object.entries(CUSTOM_TYPES).map(([key, value]) => ({
    value: +key,
    label: value.name
}));
